module.exports = require("./es-GT");